import { Component, OnInit, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";

import { ApiService } from "src/app/api.service";
import { TruncatedFilePipe } from "src/app/pipes";
import { FilesizePipe, DatetimePipe, TruncatedFilePipe as TruncatedFilePipe_1 } from "src/app/pipes";
import { DayPickerComponent } from "src/app/shared/day-picker/day-picker.component";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-files-datafile",
	templateUrl: "./files-datafile.component.html",
	styleUrls: ["./files-datafile.component.scss"],
	imports: [FormsModule, DayPickerComponent, FilesizePipe, DatetimePipe, TruncatedFilePipe_1]
})
export class FilesDatafileComponent implements OnInit {
	private api = inject(ApiService);
	private route = inject(ActivatedRoute);

	public datafiles: APIResults.DataFile[];
	public expandFilename = true;

	public startDate: string;
	public endDate: string;

	async ngOnInit(): Promise<void> {
		await this.RefreshData();
	}

	public async RefreshData() {
		this.datafiles = undefined;
		const assetId = this.route.snapshot.params["assetid"];
		const filetype = this.route.snapshot.params["filetype"];
		const datafiles = await this.api.GetDataFiles(assetId, filetype, this.startDate, this.endDate, 0, (this.startDate && this.endDate) ? undefined : 1000);
		this.datafiles = datafiles;
	}

	public async DownloadFile(datafile: APIResults.DataFile) {
		let filename;
		if (this.expandFilename) {
			filename = datafile.filename.replace("/", "_");
		} else {
			filename = new TruncatedFilePipe().transform(datafile.filename);
		}
		const assetId = this.route.snapshot.params["assetid"];
		await this.api.DownloadDataFile(assetId, datafile.datafile_id, filename);
	}
}
